module.exports = __webpack_public_path__ + "img/zanwuchanpin.588b30e4.png";